// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"e0a3b6fe","784":"73bdbc6e","856":"54d99242"}[chunkId] + ".chunk.js";
};